import { NgModule } from 'ng-metadata/core';

ngStorageConfig.$inject = ['$localStorageProvider'];
export function ngStorageConfig($localStorageProvider) {
  $localStorageProvider.setKeyPrefix('govworks-');
}



// WEBPACK FOOTER //
// ./resources/assets/js/config/local-storage.config.ts